<template>
  <section class="content-header">
    <h1>Informe de tipos de daños</h1>
  </section>

  <section class="content">
    <div class="box box-primary">
      <div class="box-body">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="compania">Compañía</label>
              <Dropdown v-model="companyia" inputId="compania"
                :options="companyias" optionLabel="nombre" optionValue="id_companyia"
                filter placeholder="Todas las compañías" class="w-100" />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group">
              <label for="tipo_danyo">Tipo de daño</label>
              <Dropdown v-model="tipoDanyo" inputId="tipo_danyo"
                :options="tiposDanyo" optionLabel="nombre" optionValue="id_tipo_danyo"
                filter placeholder="Todos los tipos de daños" class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="fecha_inicio">Fecha inicio</label>
              <Calendar v-model="fechaInicio" inputId="fecha_inicio"
                dateFormat="dd/mm/yy" showIcon class="w-100" />
            </div>
          </div>

          <div class="col-md-2">
            <div class="form-group">
              <label for="fecha_fin">Fecha fin</label>
              <Calendar v-model="fechaFin" inputId="fecha_fin"
                dateFormat="dd/mm/yy" showIcon class="w-100" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="botonera">
              <button class="btn btn-primary" @click="cargarInforme" :disabled="generando">
                <i class="fa" :class="generando ? 'fa-spinner fa-spin' : 'fa-file-pdf-o'"></i>
                {{ generando ? 'Generando...' : 'Generar documento' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <form id="FormInforme" method="post" target="VentanaInforme" style="display:none"></form>
  </section>
</template>

<script>
import { PwgsApi } from '../../../services/PwgsApi';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';

export default {
  components: { Dropdown, Calendar },

  data() {
    const hoy = new Date();
    return {
      companyias: [],
      companyia: '0',
      tiposDanyo: [],
      tipoDanyo: '',
      fechaInicio: new Date(hoy.getFullYear(), hoy.getMonth(), 1),
      fechaFin: hoy,
      generando: false
    };
  },

  methods: {
    formatearFecha(fecha) {
      if (!fecha) return '';
      const d = String(fecha.getDate()).padStart(2, '0');
      const m = String(fecha.getMonth() + 1).padStart(2, '0');
      return `${d}/${m}/${fecha.getFullYear()}`;
    },

    async cargarInforme() {
      window.open('', 'VentanaInforme');

      this.generando = true;
      try {
        const api = new PwgsApi();

        const html = await api.post('informes/informe_tipo_danyos', {
          tipo_respuesta: 'pdf',
          id_companyia: this.companyia,
          id_tipo_danyo: this.tipoDanyo,
          fecha_inicio: this.formatearFecha(this.fechaInicio),
          fecha_fin: this.formatearFecha(this.fechaFin)
        });

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const formOrigen = doc.querySelector('#form_informe');
        if (!formOrigen) {
          console.error('La API no devolvió el formulario esperado', html);
          return;
        }

        let direccion = localStorage.getItem('direccion');
        if (direccion == 'null.pwgs.app') direccion = 'pwgs5.local';

        const form = document.getElementById('FormInforme');
        form.innerHTML = '';
        form.action = 'https://' + direccion + formOrigen.getAttribute('action');

        const anyadir = (nombre, valor) => {
          const i = document.createElement('input');
          i.type = 'hidden';
          i.name = nombre;
          i.value = valor;
          form.appendChild(i);
        };

        // La compañía la mandamos aparte: "todas" es 0, no cadena vacía
        formOrigen.querySelectorAll('input').forEach(input => {
          if (input.name === 'companyia') return;
          anyadir(input.name, input.value);
        });

        anyadir('companyia', this.companyia || '0');
        anyadir('Generar', 'Generar documento');

        form.submit();
      } finally {
        this.generando = false;
      }
    },

    async cargarFiltros() {
      const api = new PwgsApi();
      const respuesta = await api.get('informes/informe_tipo_danyos');
      const filtros = respuesta.filtros || (respuesta.informes && respuesta.informes.filtros) || [];

      const fCompanyias = filtros.find(f => f.nombre_campo === 'id_companyia');
      const fTiposDanyo = filtros.find(f => f.nombre_campo === 'id_tipo_danyo');

      // En este informe "todas las compañías" se envía como 0
      this.companyias = fCompanyias ? fCompanyias.valores : [];
      if (this.companyias.length && this.companyias[0].id_companyia === '') {
        this.companyias[0] = { id_companyia: '0', nombre: 'Todas las compañías' };
      }
      this.companyia = '0';

      this.tiposDanyo = fTiposDanyo ? fTiposDanyo.valores : [];
      this.tipoDanyo = '';
    }
  },

  mounted() {
    this.cargarFiltros();
  }
};
</script>

<style scoped>
.form-group label {
  display: block;
  font-weight: 600;
  margin-bottom: 5px;
}

.w-100 :deep(.p-dropdown),
.w-100 :deep(.p-calendar),
.w-100 :deep(.p-inputtext) {
  width: 100%;
}

.botonera {
  display: flex;
  align-items: center;
  gap: 8px;
}
</style>